export default __webpack_public_path__ + "static/media/22.6e7538b1.jpg";